<template>
  <!--新品上市页面-->
  <tk-container
    :status="status"
    :probeType="3"
    infiniteScroll
    hide-status-bar
    @refresh="refreshInit"
    @scroll="watchScroll"
    class="new-products-bg"
    :style="{background: bgColor, backgroundImage:` url(${bgSrc}) !important`}"
    ref="resetNewProductsMarket"
    @loadingMore="recommendedProducts"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="true"
                     :is-header-color="isHeaderColor" :back-style="isHeaderColor ? false : true" :icon-name="'return'">
      <div slot="center-menu" :style="{color: isHeaderColor ? '#000000' : '#fff'}">新品上市</div>
    </gradient-header>
    <!--背景图渲染-->
    <div style="padding-top: 70px;">
      <!--装饰图渲染-->
      <div class="p-x-12" @click="linkPage">
        <div class="new-products-decoration" :style="`background-image: url(${decorationSrc}) !important`"></div>
      </div>
      <!--近日上新数据渲染-->
      <div class="p-x-12 m-t-15">
        <linear-card
          class="p-b-8"
          :width="100" :height="200"
          :linear-bottom-color="'rgba(255,255,255,0)'"
          :linear-top-color="'rgba(255,218,205,1)'"
          :commodity-arr="recentlyProducts"
          :type="'newProductsMarket'"
          :title="'近日上新'"
          :is-more="false"
        >
          <tk-flex wrap v-if="recentlyProducts.length">
            <lookCommodity
              class="p-x-12 p-t-8"
              v-for="(s, index) in recentlyProducts"
              :key="index"
              :commodity="s"
              :selling-color="'rgba(201, 85, 44, 1)'"
              :selling-bg="'rgba(255, 235, 228, 1)'"
              :is-border="true"
              :is-raised="false"
              :is-rounded="false"
            >
            </lookCommodity>
          </tk-flex>
          <empty-tips v-else :height="200" :width="100" :empty-msg="'暂无上新数据'"></empty-tips>
        </linear-card>
      </div>
    </div>
    <!--为你推荐数据-->
    <infinite-list :title="'为你推荐'" :infinite-list-pad="'p-x-12'" :products-data="getPriceProcessing(recommendedProductsData, judgeTimeRule)" :color="'#000000'"></infinite-list>
  </tk-container>
</template>

<script>
import linearCard from '@/components/linearCard'
import lookCommodity from '@/components/lookCommodity'
import { priceProcessing } from '@/assets/help/tool'
export default {
  components: {
    linearCard,
    lookCommodity
  },
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      isHeaderColor: false, // 判断头部颜色切换
      themeBackground: null, // 主题背景图片
      newProducts: [], // 新品上市数据
      timeRule: {}, // 限时抢购时间规则
      recommendedProductsData: [] // 为你推荐商品数据获取
    }
  },
  computed: {
    // 背景图src
    bgSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.image)) { return '' }
      return this.themeBackground.image
    },
    // 背景颜色
    bgColor () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.bgColor)) { return '' }
      return this.themeBackground.bgColor
    },
    // 装饰图src
    decorationSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.decoration)) { return '' }
      return this.themeBackground.decoration
    },
    // 今日上新数据
    recentlyProducts () {
      if (!this.newProducts.length) { return [] }
      return this.newProducts
    },
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    }
  },
  activated () {
    this.setStatusBar('light')
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
    * 页面初始化
    * @date: 2020/4/8
    */
    async getInit () {
      try {
        await this.getThemeBackground() // 获取主题图片
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        await this.getNewProducts() // 获取新品数据（获取8个）
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.recommendedProductsData = []
      await this.getInit()
      this.$refs.resetNewProductsMarket.resetInfiniteScroll()
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
     * 获取主题图片
     * @date: 2020/4/8
     */
    async getThemeBackground () {
      let themeBackground = await this.$tkParse.getList('/classes/themeBackground', {
        params: {
          limit: 1,
          order: '-createdAt',
          include: 'link',
          where: {
            position: 'newProducts'
          }
        }
      })
      if (themeBackground.length) { this.themeBackground = themeBackground[0] } else {
        this.themeBackground = null
      }
    },
    /**
    * link到商品详情
    * @date: 2020/4/27
    */
    async linkPage () {
      if (!this.themeBackground.link) { return }
      this.$push({ path: '/commodity/productDetails', query: { id: this.themeBackground.link.objectId } })
    },
    /**
     * 新品上市数据获取
     * @date: 2020/3/20
     */
    async getNewProducts () {
      let newProducts = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 50,
          // order: '-createdAt',
          order: 'weight,-updatedAt',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      if (newProducts.length) { this.newProducts = priceProcessing(newProducts, this.judgeTimeRule) } else { this.newProducts = [] }
    },
    /**
     * 为你推荐数据获取
     * @date: 2020/3/24
     */
    async recommendedProducts (page, next) {
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      this.recommendedProductsData = [...this.recommendedProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    }
  }
}
</script>

<style scoped lang="scss">
  /*背景图样式*/
.new-products-bg {
  width: 100%;
  min-height: 343px;
  background-repeat: no-repeat !important;
  background-size: 100% 343px !important;
  background-attachment: fixed;
}
  /*装饰图片样式*/
  .new-products-decoration {
    width: 100%;
    height: 195px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
</style>
